module.exports = __webpack_public_path__ + "media/images/GetGo-f34c7feb68dad455d844a3baa9e1bc04.png";